<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
  export default {
    name: 'Guest',
  };
</script>

<style scoped>

</style>